<template>
  <div class="rootDiv">
    <div class="title-container">
      <span style="font-size: 30px;color: green">浏览QQ空间留言板</span>
      <p style="font-size: 14px;color: gray">请打开手机QQ，用摄像头扫码，不支持截屏扫码</p>
    </div>
    <Button size="large" class="addbutton" @click="getLoginQRCodeFunction">点击获取QQ空间登录二维码</Button>
    <div class="img-container">
      <!-- 页面其他内容 -->
      <FullPageProgressBar :show="isProgressBarVisible" :progress="percent" :QRCodeData="QRCodeData"
                           :ShowMessage="ShowMessage"/>
    </div>
  </div>
</template>

<script>
import FullPageProgressBar from "@/controls/FullPageProgressBar";

export default {
  name: "QzoneLogin",
  components: {
    FullPageProgressBar
  },
  data() {
    return {
      ShowMessage: '请用手机QQ扫码登录',
      QRCodeData: null,
      timer: null,
      percent: 0,
      countdown: 180, // 初始值为3分钟的秒数
      isProgressBarVisible: false,
      MessageList: [],
      getLoginQRCodeUrl: '/api/qzone/getLoginQRCode',
      getWorkingProgressUrl: '/api/qzone/getWorkingProgress',
    }
  },
  mounted() {
    // 尝试监听页面刷新，但请注意这可能不适用于所有情况
    window.addEventListener('beforeunload', this.clearTimerOnRefresh);

    let loginQQ = localStorage.getItem('loginQQ')
    if (loginQQ !== null && loginQQ !== 'null' && loginQQ !== undefined) {
      this.$router.push('qzone_tool')
    } else {
      let QzoneloginSig = localStorage.getItem('QzoneloginSig')
      if (QzoneloginSig !== null && QzoneloginSig !== 'null' && QzoneloginSig !== undefined) {
        this.ShowMessage = ''
        let qrCodeData = localStorage.getItem('loginSigData')
        if (qrCodeData === 'null') {
          this.QRCodeData = require('../../../../assets/images/downloading.png')
        } else {
          this.QRCodeData = qrCodeData
        }
        this.getWorkingProgressFunction();
      }
    }
  },
  beforeDestroy() {
    // 清除定时器
    this.clearTimer();
    // 移除监听器
    window.removeEventListener('beforeunload', this.clearTimerOnRefresh);
  },
  methods: {
    clearTimer() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    clearTimerOnRefresh() {
      this.clearTimer();
    },
    async getLoginQRCodeFunction() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getLoginQRCodeUrl
      }).then((response) => {
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          that.QRCodeData = 'data:image/png;base64,' + response.data['responseData']['qRData']
          localStorage.setItem('loginSigData', that.QRCodeData)
          localStorage.setItem('QzoneloginSig', response.data['responseData']['loginSig'])
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
      await that.getWorkingProgressFunction()
    },
    async getWorkingProgressFunction() {
      let that = this
      that.percent = 0
      that.isProgressBarVisible = true
      that.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 3; // 每3秒减少计数值
        } else {
          this.clearTimer(); // 计时结束，停止定时器
        }
        that.getPercent()
      }, 3000)
    },
    async getPercent() {
      let that = this
      that.$ajax({
        method: 'get',
        params: {loginSig: localStorage.getItem('QzoneloginSig')},
        url: that.getWorkingProgressUrl
      }).then((response) => {
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          that.percent = response.data['responseData']['progress']
          that.ShowMessage = that.ChangeEnumToString(response.data['responseData']['loginState'], response.data['responseData']['qQ'])
          if (that.percent === 100) {
            localStorage.removeItem('QzoneloginSig')
            that.isProgressBarVisible = false
            this.$router.push('qzone_tool')
          } else if (that.percent > 0) {
            that.ShowMessage = '云端正在抓取QQ空间留言板，请稍后...'
          }
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    ChangeEnumToString(value, loginQQ) {
      if (value === 'Effective')
        return '等待用户扫码登录...'
      else if (value === 'Authenticating') {
        localStorage.removeItem('loginQQ')
        localStorage.removeItem('loginSigData')
        return '用户已扫码，等待用户确认登录...'
      } else if (value === 'QRExpired') {
        localStorage.removeItem('loginQQ')
        localStorage.removeItem('loginSigData')
        localStorage.removeItem('QzoneloginSig')
        return '二维码已失效，请重新获取二维码'
      } else if (value === 'Logged') {
        localStorage.removeItem('loginSigData')
        this.QRCodeData = require('../../../../assets/images/downloading.png')
        localStorage.setItem('loginQQ', loginQQ)
        return '用户登陆成功'
      } else {
        localStorage.removeItem('loginSigData')
        localStorage.removeItem('loginQQ')
        localStorage.removeItem('QzoneloginSig')
        return '用户未登录，请重新获取二维码'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin: -8px;
  display: flex; /* 激活Flexbox布局模式 */
  flex-direction: column; /* 设定子元素垂直排列 */
}

.title-container {
  margin-top: 1rem;
}

.img-container {
  display: flex; /* 激活Flexbox布局模式 */
  flex-direction: row; /* 设定子元素水平排列 */
  justify-content: center;
}

.addbutton {
  background: lightseagreen;
  margin: 2rem;
  height: 30px;
}
</style>
